import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/vars';
  @import 'src/common/styling/_mixins-scss/rem';

  .ChallengesBlock {
    margin-bottom: 45px;
    .ChallengeAccountsItemWrapper {
      margin-bottom: 2px;
    }
  }

  .ChallengesBlock__head {
    margin-bottom: 25px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    h3 {
      position: relative;
      display: inline-block;
      width: auto;
      height: auto;
      padding-right: 25px;
      @include respond-to(xs) {
        width: 100%;
        margin-bottom: 15px;
      }
    }
  }

  .ChallengesBlock__body {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .ChallengesBlock__head-right-buttons {
    display: flex;
    gap: 16px;
  }
`;

export { staticStyles };
